import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "https://pingbk.blutec.ai";

const exploreAPI = axios.create({
  baseURL: `${API_BASE}/api/explore-chatbot`,
  headers: { "Content-Type": "application/json" },
});

// No auth token needed for explore chatbot (public)

export const saveKnowledgeBase = (data) =>
  exploreAPI.post("/knowledge-base", data);

export const sendExploreChatMessage = (data) =>
  exploreAPI.post("/chat", data);

export const submitFeedback = (data) =>
  exploreAPI.post("/feedback", data);

export const generateIntroduction = (knowledgeBase) =>
  exploreAPI.post("/generate-introduction", { knowledgeBase });

export const scrapeWebsite = (data) =>
  exploreAPI.post("/scrape-website", data);

export default exploreAPI;

